<div class="registration-overlay">
  <div class="registration-card">

    <div class="header">
        <span class="username">{{authService.getDisplayName()}}</span>
        <svg class="circle-user" lucideCircleUser></svg>
    </div>

    <header class="card-header">
      <div class="logo-container">
        <img class="aguai-logo" src="images/aguai-logo.png" alt="Aguaí FC Logo">
      </div>
      <h2 class="competition-title">Peneira Aguaí 2026</h2>
      <p class="subtitle">Seu cadastro foi efetuado para participar da Peneira do Aguaí. Agora é a hora de competir e
        ganhar a sua vaga. Performe os oito exercícios no mais alto nível e torça para ser convocado.</p>
    </header>

    <div class="success-text">
      <img class="success-logo" src="images/fi_check-circle.png" alt="Success Logo">

      <h3 class="registration-success-text">Cadastro efetuado</h3>
      <a class="app-link" href="cuju://cuju/leaderboard">Voltar para CUJU</a>
    </div>

  </div>
</div>